document.querySelectorAll('.ActionsList').forEach(ActionsListInit);

function ActionsListInit(el) {
   const count = el.querySelector('.ActionsList__list').childElementCount;
   el.style.setProperty('--count', count.toString());

   el.querySelector('.ActionsList__target').addEventListener('click', (e) => {
      e.preventDefault();
      if(toggle()) {
         ClickOutside.addListener(el, () => toggle(false));
      }
      else {
         ClickOutside.removeListener(el);
      }
   });

   function toggle(state) {
      return el.classList.toggle('ActionsList--active', state);
   }
}
